import React from "react";
import Layout from "../components/Layout";
import VoucherEditOtpCard from "../components/VoucherEditOtpCard";

export default function VoucherOtpRequestsPage() {
  return (
    <Layout title="Voucher Approval">
      <VoucherEditOtpCard />
    </Layout>
  );
}
